import { connect } from 'react-redux';
import { getSearchQuery } from 'store/reducers/search';
import NoResults from './NoResults';

const mapStateToProps = (state) => ({
  query: getSearchQuery(state),
});

export default connect(mapStateToProps)(NoResults);
